// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

export const WILDCARD = '************'
export const WILDCARDBSON = '2a2a2a2a2a2a2a2a2a2a2a2a'

export const PERMISSIONS = {
  READ: 1,
  MODIFY: 2,
  CREATE: 3,
  DELETE: 4
}



//////////////////
// WEBPACK FOOTER
// ./~/@sdgsystems/vue-common/components/constants.js
// module id = 12
// module chunks = 0